import { getContainerTypes } from "../productCommons/index.js";

export type PriceTierDiscountType = "percentage" | "perpetual-flat";

export type PriceTierDiscountItemType =
  | "keg"
  | "can"
  | "cask"
  | "bottle"
  | "draught"
  | "bagInBox";

export type PriceTierDiscount = {
  type: PriceTierDiscountType;
  deletedAt: Date;
  amount: number;
  itemType: PriceTierDiscountItemType | undefined;
  minimumBasketValue: number;
  quantity: number;
};

export const isItemApplicableToDiscount = ({
  containerType,
  discountable,
  discountItemType,
}: {
  containerType: string | null;
  discountable: boolean;
  discountItemType: PriceTierDiscountItemType | null;
}) => {
  // e.g. a badge

  if (containerType === null) {
    return false;
  }

  // check item container matches discount container and item is discountable

  if (discountItemType) {
    const isDiscountApplicableToItemContainerType =
      getContainerTypes(containerType).includes(discountItemType);

    return discountable && isDiscountApplicableToItemContainerType;
  }

  // discount container type is 'any' and therefore item is applicable if discountable

  return discountable;
};

export const filterDiscountApplicableItems = <
  T extends {
    containerType: string | null;
    discountable: boolean;
  },
>({
  orderItems,
  discountItemType,
}: {
  orderItems: T[];
  discountItemType: PriceTierDiscountItemType | null; // 'null' item type corresponds to 'any' item type
}) => {
  return orderItems.filter((orderItem: T) =>
    isItemApplicableToDiscount({
      containerType: orderItem.containerType,
      discountable: orderItem.discountable,
      discountItemType,
    }),
  );
};
